import { render, staticRenderFns } from "./UiPagination.vue?vue&type=template&id=3253242a&"
import script from "./UiPagination.vue?vue&type=script&lang=js&"
export * from "./UiPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports